// import { Modal } from 'antd';

// export const Severty = {
//     SUCCESS: 'success',
//     ERROR: 'error'
// }

// export const ShowToast = (message, type) => {

//     switch (type) {
//         case 'success':
//             Modal.success({
//                 content: message,
//                 centered: true,
//                 width: 400,
//                 okText: 'OK'
//             });
//             break;
//         case 'error':
//             Modal.error({
//                 content: message,
//                 centered: true,
//                 width: 400,
//                 okText: 'OK'
//             });
//             break;
//         default:
//             break;
//     }
// }

import { toast } from "react-toastify";

export const Severty = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
};

export const ShowToast = (message, type) => {
  switch (type) {
    case "success":
      toast.success(message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      break;
    case "error":
      toast.error(message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      break;
    case "info":
      toast.info(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      break;
    default:
      break;
  }
};
